<template>
        <router-link 
            :to="route" 
            class="is-size-5"
            v-on:click.native="$emit('click')">
            <div class="slideout-navbar-item">
                {{title}}

            </div>
        </router-link>
</template>

<script>
    export default {
        props: ['title', 'route'],
    }
</script>

<style lang="scss">
    @import 'globalStyles';

    .slideout-navbar-item {
        width: 100%;
        text-align: center;
        // border-bottom: 1px solid $greySeparator;
        border-top: 1px solid $greySeparator;

        padding: 0.5em 0em;
        
        overflow: hidden;
        white-space: nowrap;
        word-wrap: unset;
    }

    .slideout-navbar-item:hover {
        background-color: $lightGrey;
    }

</style>


// WEBPACK FOOTER //
// src/components/header/NavigationItem.vue